export default "__VITE_ASSET__7f42a3d2__"